import { render, staticRenderFns } from "./_.vue?vue&type=template&id=70cc8650"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreateYourOwn: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/CreateYourOwn.vue').default,HalfNHalf: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/HalfNHalf.vue').default,Product: require('/home/uattopspizzaco/builds/t3_dxX7hs/0/standbyteam/topspizza.co.uk/frontend/web/components/Product.vue').default})
